import { Image } from 'shared/components/image';
import { View } from 'react-native';
import { Text } from 'shared/components/text';
import React from 'react';
import { BreederPet } from 'shared/@generated/models';
import { useFormatter } from 'shared/library/use-formatter';
import { useTranslation } from 'react-i18next';
import { getBreederPetImageAsset } from 'shared/library/get-model-image';

export const BreederPetCard = ({ pet }: { pet: BreederPet }) => {
  const { t } = useTranslation('components');
  const { formatDateAsAge } = useFormatter();
  const petImage = getBreederPetImageAsset(pet) ?? '';

  return (
    <View
      className={
        'border-brand-brown-dark/15 gap-3 rounded-lg border bg-white p-3 md:flex-row md:items-start md:gap-5 md:p-5'
      }
    >
      <Image
        src={petImage}
        alt={pet.name}
        containerClassName={'aspect-4/3 w-full md:w-1/3'}
        imageClassName={'rounded-lg object-cover'}
        sizeType={'card'}
      />

      <View className={'flex-1'}>
        <Text className={'text-brand-brown-dark text-lg font-bold md:text-xl'}>{pet.name}</Text>
        <Text className={'text-brand-brown-dark/70 text-sm'}>
          {pet.breed.name} · {t(`common:enums.gender.${pet.gender}`)} ·{' '}
          {formatDateAsAge(pet.birth_date)}
        </Text>

        <Text className={'text-brand-brown-dark mt-3'}>{pet.description ?? ''}</Text>
      </View>
    </View>
  );
};
